import { Ref } from 'vue';
import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseCreateWatchlistConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useCreateWatchlist(
  title: Ref<string>,
  { onSuccess, onReject }: UseCreateWatchlistConfigs
) {
  const {
    execute: addNewWatchlist,
    isPending: isCreatingWatchlist,
    ...query
  } = useMutation(() => API.creatNewWatchlist({ title: title.value }), {
    onSuccess,
    onReject,
  });

  return { addNewWatchlist, isCreatingWatchlist, ...query };
}
